import { useState, useEffect } from "react";

import { AxiosError } from "axios";
import { TcuAvailableSlot } from "api/appointment/GetTcuAvailableSlots/getTcuAvailableSlots.toUi.types";
import { getTcuAvailableSlots } from "api/appointment/GetTcuAvailableSlots/getTcuAvailableSlot";
import { mapApiDataToProps } from "api/appointment/GetTcuAvailableSlots/mapper/mapper";

interface useGetTcuAvailableSlotsResponse {
  availableSlots: TcuAvailableSlot[];
  isLoading: boolean | null;
  hasErrored: boolean | null;
  errorMessage: string | null;
}

const useGetTcuAvailableSlots = (
  pageRefresh: boolean,
  memberIdentifier: string | null,
  institutionCode: string,
  regInstitutionCode: string,
): useGetTcuAvailableSlotsResponse => {
  const [availableSlots, setAvailableSlot] = useState<TcuAvailableSlot[]>([]);
  const [isLoading, setIsLoading] = useState<boolean | null>(null);
  const [hasErrored, setHasErrored] = useState<boolean | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const responseData = await getTcuAvailableSlots(
          memberIdentifier,
          institutionCode,
          regInstitutionCode,
        );

        const availableSlotList = mapApiDataToProps(responseData);
        setAvailableSlot(availableSlotList);

        if (availableSlotList.length < 1) {
          setHasErrored(true);
          setErrorMessage(responseData?.Message);
        } else {
          setHasErrored(false);
        }
      } catch (error) {
        setAvailableSlot([]);
        setHasErrored(true);
        if (error instanceof AxiosError) {
          setErrorMessage(error.response?.data.Message);
        }
      } finally {
        setIsLoading(false);
      }
    })();
  }, [pageRefresh, memberIdentifier, institutionCode, regInstitutionCode]);

  return {
    availableSlots,
    isLoading,
    hasErrored,
    errorMessage,
  };
};

export { useGetTcuAvailableSlots };
